export default __webpack_public_path__ + "aef5350856b4c9419b01cf3923725038.svg";